export default {
  amber: "Amber",
  hutao: "Hu tao"
};
